import { useSyncExternalStore } from 'react';

const CHECK_WINDOW_MS = 15 * 60_000;

let checkingUntil = 0;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

const subscribe = (listener: () => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

export const isCheckingReconnection = () => Date.now() < checkingUntil;

export const markReconnected = () => {
	checkingUntil = Date.now() + CHECK_WINDOW_MS;
	emit();
	window.setTimeout(emit, CHECK_WINDOW_MS + 100);
};

export const useCheckingReconnection = () => useSyncExternalStore(subscribe, isCheckingReconnection);
